export const pravenStatus =
    [
        {
            id: "true", ime: "Правно"
        },
        {
            id: "false", ime: "Физичко"
        }
    ]